export const GSU_STEP_NAME_MAPPER = {
    'job-preference': 'user-preference',
    certification: 'certification-questioner',
    address: 'user-address',
    'protected-information' : "protected_information" ,
  };